<template lang="html">
  <section class="modal-card" v-if="purchase">
    <header v-if="owner" class="modal-card-head is-paddingless px-5 py-2">
      <p class="modal-card-title">Purchase</p>
      <!-- Edit button -->
      <span class="p-1">
        <b-tooltip label="Edit purchase" type="is-warning is-inverted" position="is-left">
          <b-button
            class="is-warning is-inverted"
            @click="isUpdatePurchaseModalActive = true"
          >
            <b-icon icon="pencil"></b-icon> </b-button
        ></b-tooltip>
      </span>
      <image-management
        v-if="owner"
        :imageable-id="purchase.id"
        :imageable-type="'purchase'"
        @imagesUpdated="images = $event"
      />
    </header>
    <header v-else class="modal-card-head">
      <p class="modal-card-title">Purchase</p>
      <!-- Close button -->
      <button type="button" class="delete" @click="$parent.close()" />
    </header>
    <section class="modal-card-body">
      <div class="columns is-centered is-multiline p-3">
        <div class="column">
          <h1 class="title is-size-4 is-inline has-text-dark-orange">
            {{ purchase.attributes.name }}
          </h1>
          <b-tooltip
            position="is-right"
            type="is-dark-orange"
            :label="purchase.attributes.craft_purchase_category.data.attributes.name"
          >
            <b-icon
              type="is-dark-orange"
              :icon="
                craftPurchaseGetIconName(
                  purchase.attributes.craft_purchase_category.data.id
                )
              "
            ></b-icon>
          </b-tooltip>
        </div>

        <div class="column is-narrow has-text-right">
          <b-tooltip
            type="is-light"
            position="is-bottom"
            :label="simpleDateFormat(purchase.attributes.created_at)"
            animated
          >
            <small class="has-text-gray is-italic"
              >Created {{ dateFromNow(purchase.attributes.created_at) }}</small
            >
          </b-tooltip>
        </div>
        <div class="column is-full is-paddingless px-3">
          <span class="has-text-weight-semibold">Description </span>
          <b-tooltip
            position="is-right"
            type="is-dark"
            mulitlined
            size="is-small"
            label="Description of the Purchase, context of Purchase, price and quantity."
          >
            <b-icon size="is-small" icon="help-circle-outline"></b-icon>
          </b-tooltip>
          <p class="has-text-justified">{{ purchase.attributes.description }}</p>

          <span v-if="store" class="ellipsis is-italic has-text-gray pt-2">
            Found at
            <router-link
              aria-current="store"
              :to="{ path: `/stores/${store.attributes.nickname}` }"
            >
              <span class="has-text-primary has-text-weight-semibold">{{
                store.attributes.name
              }}</span>
            </router-link>
          </span>
        </div>
        <div class="column is-full">
          <carousel-vertical :images="images">
            <template v-slot:header
              ><span class="heading is-size-7 has-text-dark-orange pr-2">Tags</span>
              <tag-list
                class="is-inline-block"
                :tags="purchase.attributes.tag_list"
                v-bind:slice-index="images.length > 1 ? 2 : 5"
              />
            </template>
          </carousel-vertical>
        </div>
      </div>
    </section>

    <footer class="modal-card-foot">
      <span class="card-footer-item">
        <b-button @click="$parent.close()"> Close </b-button>
      </span>
    </footer>

    <b-modal
      :active.sync="isUpdatePurchaseModalActive"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
    >
      <update-purchase-modal :purchase="purchase" @purchaseUpdated="purchaseUpdated">
      </update-purchase-modal>
    </b-modal>
  </section>
</template>

<script>
// Mixins
import { mapGetters } from 'vuex'
import { dateMixin } from '@/mixins/dateMixin.js'
import { craftPurchaseCategoryMixin } from '@/mixins/craftPurchaseCategoryMixin'

// Components
import CarouselVertical from '@/components/concerns/Images/CarouselVertical'
import ImageManagement from '@/components/concerns/Images/ImageManagement'
import UpdatePurchaseModal from '@/views/Project/UpdatePurchaseModal'
import TagList from '@/components/concerns/Tags/TagList'

export default {
  props: ['purchase'],
  mixins: [dateMixin, craftPurchaseCategoryMixin],
  data () {
    return {
      isUpdatePurchaseModalActive: false,
      images: []
    }
  },
  components: {
    CarouselVertical,
    ImageManagement,
    UpdatePurchaseModal,
    TagList
  },
  created () {
    this.fetchImages()
  },
  methods: {
    purchaseUpdated (values) {
      this.$emit('purchaseUpdated', values)
    },
    fetchImages () {
      this.$store
        .dispatch('images/index', {
          imageableType: 'purchase',
          imageableId: this.purchase.id
        })
        .then((resp) => {
          this.images = resp.data.data
        })
        .catch((error) => {
          console.log('error')
          console.log(error.response)
        })
    }
  },
  computed: {
    ...mapGetters({
      isOwner: 'isOwner'
    }),
    owner () {
      return this.isOwner(this.purchase.attributes.user_id)
    },
    store () {
      return this.purchase.attributes.store.data
    }
  }
}
</script>

<style lang="scss" scoped></style>
